/**
 * True when both bounds are non-empty and the end is strictly before the start.
 * Works for ISO day strings (YYYY-MM-DD…) and month keys (YYYY-MM) — lexicographic order matches calendar order.
 */
export function isReportRangeOrderInvalid(start: string, end: string): boolean {
  const a = start?.trim()
  const b = end?.trim()
  if (!a || !b) return false
  return a > b
}
